import { Component, EventEmitter, Input, Output } from '@angular/core';
import { notifyMessage } from '../../../shared/constants/notify-message';
import { SelectedQuota } from '../../../shared/interfaces/quota.interface';
import { QUALIFICATION_CODES } from '../../../shared/constants/qualification-code';
import { ToasterService } from '@purespectrum1/ui/toaster-service';

@Component({
  selector: 'ps-ui-group-quota',
  templateUrl: './group-quota.component.html',
  styleUrls: ['./group-quota.component.css'],
})
export class GroupQuotaComponent {
  @Input() quotas: SelectedQuota[] = [];
  @Input() showGroupButton: boolean = false;
  @Input() isCensusApplied: boolean = false;
  @Input() isSelectedForAida: boolean = false;
  public groupQuotaArray: SelectedQuota[] = [];
  @Input() qualificationCode?: number;
  @Output() readonly quotaChangedStatus = new EventEmitter();
  @Output() readonly outputGroupedQuotas = new EventEmitter();

  constructor(private _toastr: ToasterService) {}

  public groupConditions() {
    this.quotas = this.quotas.filter(
      (element: SelectedQuota) => element.selectedForGroup === false
    );
    this.showGroupButton = true;
    this.quotaChangedStatus.emit(this.showGroupButton);
    this.groupQuotaArray = [];
  }

  public cancelGroupConditions() {
    this.quotas.forEach((quota) => {
      quota.selected = true;
      quota.selectedForGroup =
        quota.oldQuotasText && quota.oldQuotasText.length > 1;
    });
    this.showGroupButton = false;
    this.quotaChangedStatus.emit(this.showGroupButton);
    this.groupQuotaArray = [];
  }

  public groupQuotas() {
    if (this.isSelectedForAida) {
      this._toastr.error(
        notifyMessage.errorMessage.AIDA.LIVE_QUOTA_CHANGE_RESTRICTION
      );
      return;
    }
    if (!this.groupQuotaArray.length) {
      this.groupQuotaArray = this.quotas.filter(
        (quota) =>
          quota.selectedForGroup &&
          quota.oldQuotasText &&
          quota.oldQuotasText?.length <= 1
      );
    }
    if (
      this.isCensusApplied &&
      [QUALIFICATION_CODES.EMPLOYMENT, QUALIFICATION_CODES.EDUCATION].includes(
        this.qualificationCode ?? 0
      )
    ) {
      this._toastr.warning(notifyMessage.warningMessage.GROUPING_CENSUS_REPO);
      this.cancelGroupConditions();
    } else if (this.groupQuotaArray.length >= 2) {
      this.showGroupButton = false;
      this.quotaChangedStatus.emit(this.showGroupButton);
      this.outputGroupedQuotas.emit(this.groupQuotaArray);
    } else {
      this._toastr.warning(notifyMessage.warningMessage.GROUPING_SINGLE_QUOTA);
    }
  }

  public selectQuota(selectedQuota: SelectedQuota) {
    // if already exists then remove the quota from quotas else add
    const found = this.groupQuotaArray.some(
      (quota: SelectedQuota) => quota.text === selectedQuota.text
    );
    if (!found) {
      selectedQuota.selectedForGroup = true;
      selectedQuota.selected = false;
      this.groupQuotaArray.push(selectedQuota);
    } else if (found) {
      selectedQuota.selectedForGroup = false;
      selectedQuota.selected = true;
      this.groupQuotaArray = this.groupQuotaArray.filter(
        (quota: SelectedQuota) => quota.text !== selectedQuota.text
      );
    }
  }
}
